module.exports = __webpack_public_path__ + "static/media/gulpjs.0031331b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/gulpjs.jpg
// module id = 103
// module chunks = 0